import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const ControlsAndMapContainer = forwardRef(
  ({ children, isSmallDesktop }, ref) => {
    // If the screen is smaller than small desktop we just return the children
    if (!isSmallDesktop) {
      return children;
    }

    return (
      <div
        data-testid="controls-and-map-container"
        id="controls-and-map-container"
        ref={ref}
      >
        {children}
      </div>
    );
  },
);

ControlsAndMapContainer.displayName = 'ControlsAndMapContainer';

ControlsAndMapContainer.propTypes = {
  children: PropTypes.node.isRequired,
  isSmallDesktop: PropTypes.bool.isRequired,
};

export default ControlsAndMapContainer;
